import { TableColumn } from './TableHeader.types';

export const tableColumnConfigs: Record<string, TableColumn[]> = {
  AISystemOverview: [
    {
      label: 'SYSTEM NAME',
      width: 'min-w-56',
      sortable: true,
      sortKey: 'name',
      className: 'w-full',
    },
    {
      label: 'ENTITY',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'entity',
      className: 'w-full',
    },
    {
      label: 'COMPLIANCE STATUS',
      width: 'min-w-44',
      sortable: true,
      sortKey: 'complianceStatus',
      className: 'w-full',
    },
    {
      label: 'RISK CLASSIFICATION',
      width: 'min-w-44',
      sortable: true,
      sortKey: 'riskClassification',
      className: 'w-full',
    },
    {
      label: 'OWNER',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'owner',
      className: 'w-full',
    },
    {
      label: 'ORGANIZATION',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'organization',
      className: 'w-full',
    },
  ],
  RepositoryManagement: [
    { label: 'REPOSITORY', width: 'w-1/4', sortable: true, sortKey: 'name' },
    { label: 'PROVIDER', width: 'w-1/6', sortable: true, sortKey: 'provider' },
    {
      label: 'BRANCH',
      width: 'w-1/6 min-w-[170px]',
      sortable: true,
      sortKey: 'branch',
    },
    { label: 'STATUS', width: 'w-1/6', sortable: true, sortKey: 'status' },
    {
      label: 'LAST SYNCED',
      width: 'w-1/5',
      sortable: true,
      sortKey: 'lastSynced',
    },
    { label: 'ACTIONS', width: 'w-32' },
  ],
  RegisteredUsers: [
    {
      label: 'Registered Users',
      width: 'w-[33.333%]',
      sortable: true,
      sortKey: 'name',
    },
    { label: 'EMAIL', width: 'w-[33.333%]', sortable: false },
    { label: 'Assigned ai systems', width: 'w-[16.667%]', sortable: false },
    { label: 'Last Active', width: 'w-[16.667%]', sortable: false },
  ],
  Documentation: [
    { label: 'TITLE', sortable: true, sortKey: 'fileName', width: 'w-1/3' },
    { label: 'SOURCE', sortable: true, sortKey: 'source', width: 'w-1/6' },
    { label: 'CATEGORY', sortable: true, sortKey: 'category', width: 'w-1/4' },
    {
      label: 'DATE CREATED',
      sortable: true,
      sortKey: 'createdAt',
      width: 'w-1/5',
    },
    { label: 'ACTIONS', width: 'w-32' },
  ],
};
